export const MEDIA_QUERY_CONDITION_FOR_PC = { minWidth: 768 } as const;
export const MEDIA_QUERY_FOR_PC = `@media screen and (min-width: ${MEDIA_QUERY_CONDITION_FOR_PC.minWidth}px)`;
